import type { EntityConfigDefinition, DisplayColumnConfig, FilterConfig } from '../../types/entityConfig'

const config: EntityConfigDefinition = {
  name: 'STEP_TYPE_PARAM_MAP',
  idField: 'STEP_TYPE_PARAM_MAP_ID',
  
  // Form processing configuration
  keepAuditFieldsOnUpdate: false,
  
  // Environment copy configuration
  preserveOnCopy: ['STEP_TYPE_PARAM_MAP_ID'],
  
  // Data loading configuration
  requiresServiceParamMappings: true,
  loadServiceParamMappingOptions: true,
  loadCustomFilterData: true,
  
  // Optimized query configuration
  useOptimizedQuery: true,
  optimizedQueryName: 'getFilteredStepTypeParamMaps',
  
  // Screen filters
  hasFilters: true,
  customFilters: {
    sourceService: {
      showAlways: true,
      label: 'Filter by Source Service'
    },
    targetService: {
      showAlways: true,
      label: 'Filter by Target Service'
    }
  },
  
  // Integrated filters for modal forms - these create filter dropdowns in the modal
  integratedFilters: {
    SOURCE_SERVICE_ID: {
      filterField: 'SOURCE_SERVICE_ID',
      filterLabel: 'Source Service'
    },
    TARGET_SERVICE_ID: {
      filterField: 'TARGET_SERVICE_ID',
      filterLabel: 'Target Service'
    }
  },
  
  // Modal pre-population configuration
  modalPrePopulation: {
    sourceServiceFilter: 'SOURCE_SERVICE_ID',
    targetServiceFilter: 'TARGET_SERVICE_ID'
  },
  
  // Foreign key configuration for table display
  foreignKeys: {
    STEP_TYPE_ID: {
      table: 'STEP_TYPE',
      valueField: 'STEP_TYPE_ID',
      displayField: 'STEP_TYPE_NAME'
    },
    SERVICE_PARAM_MAPPING_ID: {
      table: 'SERVICE_PARAM_MAPPING',
      valueField: 'SERVICE_PARAM_MAPPING_ID',
      displayField: 'SERVICE_PARAM_MAPPING_ID'
    }
  },
  
  // Custom display for SERVICE_PARAM_MAPPING_ID
  customDisplayFields: {
    SERVICE_PARAM_MAPPING_ID: {
      enhanceFunction: 'enhanceServiceParamMappingDisplay'
    }
  },
  
  // Fields to remove before GraphQL mutations
  fieldsToRemove: ['STEP_TYPE_ID_DISPLAY', 'SERVICE_PARAM_MAPPING_ID_DISPLAY'],
  

  
  // Environment comparison configuration
  comparisonConfig: {
    matchingFields: ['STEP_TYPE_ID', 'SERVICE_PARAM_MAPPING_ID'],
    comparisonFields: ['STEP_TYPE_ID', 'SERVICE_PARAM_MAPPING_ID'],
    useDisplayValues: {
      'STEP_TYPE_ID': 'STEP_TYPE_NAME'
    },
    displayFieldMapping: {
      'STEP_TYPE_ID': 'STEP_TYPE_NAME'
    },
    displayFields: ['STEP_TYPE_PARAM_MAP_ID', 'STEP_TYPE_ID', 'SERVICE_PARAM_MAPPING_ID', 'CREATED_BY_USER_ID', 'CREATED_DATE'],
    resolveLookupsForBothEnvironments: true
  },
  
  // Display columns with foreign key lookups
  displayColumns: [
    {
      field: 'STEP_TYPE_ID',
      lookup: {
        table: 'STEP_TYPE',
        foreignKey: 'STEP_TYPE_ID',
        displayField: 'STEP_TYPE_NAME'
      }
    },
    {
      field: 'SERVICE_PARAM_MAPPING_ID',
      lookup: {
        table: 'SERVICE_PARAM_MAPPING',
        foreignKey: 'SERVICE_PARAM_MAPPING_ID',
        displayField: 'SERVICE_PARAM_MAPPING_ID'
      }
    }
  ] as DisplayColumnConfig[],

  // Unified filter configuration
  filters: {
    table: [
      { type: 'custom', field: 'SOURCE_SERVICE_ID', label: 'Filter by Source Service' },
      { type: 'custom', field: 'TARGET_SERVICE_ID', label: 'Filter by Target Service' }
    ] as FilterConfig[],
    modal: [
      { type: 'integrated', field: 'SOURCE_SERVICE_ID', label: 'Source Service' },
      { type: 'integrated', field: 'TARGET_SERVICE_ID', label: 'Target Service' }
    ] as FilterConfig[]
  },

  // Fields configuration
  fields: [
    "STEP_TYPE_PARAM_MAP_ID",
    "STEP_TYPE_ID",
    "SERVICE_PARAM_MAPPING_ID",
    "CREATED_BY_USER_ID",
    "CREATED_DATE"
  ],
  
  // Form fields configuration
  formFields: [
    {
      "name": "STEP_TYPE_ID",
      "type": "select",
      "required": false,
      "disabled": false
    },
    {
      "name": "SERVICE_PARAM_MAPPING_ID",
      "type": "select",
      "required": true,
      "disabled": false
    },
    {
      "name": "CREATED_BY_USER_ID",
      "type": "text",
      "required": false,
      "disabled": false
    },
    {
      "name": "CREATED_DATE",
      "type": "text",
      "required": false,
      "disabled": true
    }
  ]
}

export default config

